import React, { useEffect, useRef } from 'react';
type CalendlyWindow = Window & {
  Calendly?: {
    initInlineWidget: (options: {
      url: string;
      parentElement: HTMLElement;
    }) => void;
  };
};
const SCRIPT_URL = 'https://assets.calendly.com/assets/external/widget.js';
const CALENDLY_URL = 'https://calendly.com/ashsingh/life-in-the-sikh-kingdoms';
export function CalendlyEmbed() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const initialize = () => {
      const calendlyWindow = window as CalendlyWindow;
      if (!containerRef.current || !calendlyWindow.Calendly) return;
      containerRef.current.innerHTML = '';
      calendlyWindow.Calendly.initInlineWidget({
        url: CALENDLY_URL,
        parentElement: containerRef.current
      });
    };
    const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_URL}"]`);
    if (existingScript) {
      if ((window as CalendlyWindow).Calendly) initialize();else existingScript.addEventListener('load', initialize, {
        once: true
      });
      return () => existingScript.removeEventListener('load', initialize);
    }
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.addEventListener('load', initialize, {
      once: true
    });
    document.body.appendChild(script);
    return () => script.removeEventListener('load', initialize);
  }, []);
  return <div ref={containerRef} className="calendly-inline-widget w-full" data-url={CALENDLY_URL} style={{
    minWidth: 320,
    height: 700
  }} aria-label="Book a Founding Member call with Ash Singh" data-id="element-1352" data-mp="esj9o6me8go" />;
}